export const PROJECT = 0;
export const EDITOR = 1;
export const CONFIG_CLOUD = 2;
export const CONFIG_LOCAL = 3;
export const CONFIG_ERROR = 10;
export const CONTROL_BAR = 4;
export const BOARD = 5;
export const CONSOLE = 6;
export const END = 7;

export const CLOSE = -1;


// WEBPACK FOOTER //
// ./src/constants/guide.js